<div class="page">
  <span translate="pagination.controls.itemsPerPage" class="label"> </span>

  <form [formGroup]="form">
    <pu-select
      formControlName="pageSizeOptions"
      class="select"
      [items]="pageOptions"
      data-testid="page_size_select">
    </pu-select>
  </form>

  <span class="label">
    {{ offset }} {{ 'pagination.controls.of' | translate }} {{ length() }}
    {{ 'pagination.controls.items' | translate }}
  </span>
</div>

<div class="controls">
  <button
    type="button"
    puButton
    size="s"
    [disabled]="hasFirst"
    uiType="quinary"
    (click)="toFirst()">
    <pu-icon iconName="to-first"> </pu-icon>
  </button>

  <button
    type="button"
    puButton
    size="s"
    [disabled]="hasFirst"
    (click)="prev()"
    uiType="quinary">
    <pu-icon iconName="chevron-left"> </pu-icon>
    {{ 'pagination.controls.previous' | translate }}
  </button>

  <span class="label">
    <span class="border">{{ index }}</span>
    {{ 'pagination.controls.of' | translate }} {{ totalCountOfPages }}
  </span>

  <button
    type="button"
    puButton
    size="s"
    uiType="quinary"
    [disabled]="hasLast"
    (click)="next()"
    translate="pagination.controls.next">
    <pu-icon iconName="chevron-right"> </pu-icon>
  </button>

  <button
    type="button"
    puButton
    size="s"
    [disabled]="hasLast"
    uiType="quinary"
    (click)="toLast()">
    <pu-icon iconName="to-last"> </pu-icon>
  </button>
</div>
